<template>
  <v-card>
    <v-card-title style="padding: 0">
      <v-toolbar
        color="transparent"
        density="compact"
      >
        <v-toolbar-title
          class="text-h6"
          text="Добавить объявление"
        ></v-toolbar-title>

        <template v-slot:append>
          <v-btn
            size="small"
            icon="mdi-close"
            @click="$emit('update:modelValue', false)"
          ></v-btn>
        </template>
      </v-toolbar>
    </v-card-title>
    <v-divider
      style="margin: 0"
      class="border-opacity-100"
    ></v-divider>
    <v-form
      @submit.prevent="save"
      ref="form"
    >
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-menu
              v-model="dateMenu"
              transition="scale-transition"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  :rules="formRules.notEmpty"
                  label="Объявление действует до даты"
                  prepend-inner-icon="mdi-calendar-month"
                  :readonly="id == 0 ? true : false"
                  v-model="computedDateFormatted"
                  v-bind="props"
                ></v-text-field>
              </template>
              <v-date-picker
                v-if="!id"
                v-model="dateFinishAnnounce"
                no-title
                @update:modelValue="dateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="selectedRoles"
              :rules="formRules.notEmpty"
              :items="roles"
              item-value="value"
              item-title="name"
              label="Кому отправить"
              multiple
            ></v-autocomplete>
          </v-col>
        </v-row>

        <div id="ckeditor">
          <ckeditor
            v-model="editorData"
            :rules="formRules.notEmpty"
            :editor="editor"
            :config="editorConfig"
            tag-name="textarea"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          :disabled="saveButtonReadOnly"
          text="Сохранить"
          type="submit"
        ></v-btn>

        <v-btn
          text="Закрыть"
          @click="$emit('update:modelValue', false)"
        ></v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {
  ClassicEditor,
  AccessibilityHelp,
  Alignment,
  Autoformat,
  AutoImage,
  AutoLink,
  Autosave,
  Bold,
  Base64UploadAdapter,
  CKBoxImageEdit,
  CloudServices,
  Code,
  CodeBlock,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  HtmlComment,
  HtmlEmbed,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageInsert,
  ImageInsertViaUrl,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Italic,
  Link,
  LinkImage,
  List,
  ListProperties,
  Paragraph,
  PasteFromOffice,
  PictureEditing,
  SelectAll,
  ShowBlocks,
  SourceEditing,
  Subscript,
  Superscript,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  Underline,
  Undo,
  ButtonView,
  Plugin,
  Style,
} from "ckeditor5";
import { Ckeditor } from "@ckeditor/ckeditor5-vue";

import "ckeditor5/ckeditor5.css";
import { useDate } from "vuetify";

const FIRST_LINE_INDENT_STYLE = "First line indent";

class FirstLineIndentButton extends Plugin {
  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add("firstLineIndent", (locale) => {
      const button = new ButtonView(locale);
      const command = editor.commands.get("style");

      button.set({
        label: "Красная строка",
        tooltip: true,
        withText: true,
        isToggleable: true,
      });

      button
        .bind("isEnabled")
        .to(command, "enabledStyles", (styles) =>
          styles.includes(FIRST_LINE_INDENT_STYLE),
        );

      button
        .bind("isOn")
        .to(command, "value", (styles) =>
          styles.includes(FIRST_LINE_INDENT_STYLE),
        );

      button.on("execute", () => {
        const isActive = command.value.includes(FIRST_LINE_INDENT_STYLE);
        editor.execute("style", {
          styleName: FIRST_LINE_INDENT_STYLE,
          forceValue: !isActive,
        });
        editor.editing.view.focus();
      });

      return button;
    });
  }
}
export default {
  name: "announce",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      required: true,
    },
    id: {
      required: true,
      default: 0,
    },
  },
  components: {
    Ckeditor,
  },

  watch: {
    dateFinishAnnounce: function (newVal, oldVal) {
      if (!newVal) {
        this.computedDateFormatted = "";
        return;
      }

      const [m, d, y] = this.dateFormatter
        .format(this.dateFinishAnnounce, "keyboardDate")
        .split("/");

      this.computedDateFormatted = [d, m, y].join(".");
      return;
    },
  },
  data() {
    return {
      dateFormatter: false,
      dateMenu: false,
      dateFinishAnnounce: null,
      computedDateFormatted: "",

      editor: ClassicEditor,
      editorData: "",
      saveButtonReadOnly: false,
      formRules: {
        notEmpty: [
          (value) => {
            if (value?.length >= 1) return true;
            return "Должно быть заполнено";
          },
        ],
      },
      roles: [
        {
          value: "all",
          name: "Все",
        },
        {
          value: "manager",
          name: "Администраторы",
        },
        {
          value: "teacher",
          name: "Учителя",
        },
        {
          value: "staff",
          name: "Сотрудники",
        },
        {
          value: "parent",
          name: "Родители",
        },
        {
          value: "student",
          name: "Студенты",
        },
      ],
      selectedRoles: [],
      editorConfig: {
        licenseKey: "GPL",
        plugins: [
          AccessibilityHelp,
          Alignment,
          Autoformat,
          AutoImage,
          AutoLink,
          Autosave,
          Bold,
          Base64UploadAdapter,
          CKBoxImageEdit,
          CloudServices,
          Code,
          CodeBlock,
          Essentials,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          GeneralHtmlSupport,
          Heading,
          HtmlComment,
          HtmlEmbed,
          ImageBlock,
          ImageCaption,
          ImageInline,
          ImageInsert,
          ImageInsertViaUrl,
          ImageResize,
          ImageStyle,
          ImageTextAlternative,
          ImageToolbar,
          ImageUpload,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          Paragraph,
          PasteFromOffice,
          PictureEditing,
          SelectAll,
          ShowBlocks,
          SourceEditing,
          Subscript,
          Superscript,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          Underline,
          Style,
          FirstLineIndentButton,
          Undo,
        ],
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "sourceEditing",
            "showBlocks",
            "selectAll",
            "|",
            "heading",
            "|",
            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",
            "alignment",
            "firstLineIndent",
            "|",
            "bold",
            "italic",
            "underline",
            "subscript",
            "superscript",
            "code",
            "|",
            "link",
            "insertTable",
            "codeBlock",
            "htmlEmbed",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "accessibilityHelp",
          ],
          shouldNotGroupWhenFull: true,
        },
        fontFamily: {
          supportAllValues: true,
        },
        fontSize: {
          options: [10, 12, 14, "default", 18, 20, 22],
          supportAllValues: true,
        },
        style: {
          definitions: [
            {
              name: FIRST_LINE_INDENT_STYLE,
              element: "p",
              classes: ["first-line-indent"],
            },
          ],
        },
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph",
            },
            {
              model: "heading1",
              view: "h1",
              title: "Heading 1",
              class: "ck-heading_heading1",
            },
            {
              model: "heading2",
              view: "h2",
              title: "Heading 2",
              class: "ck-heading_heading2",
            },
            {
              model: "heading3",
              view: "h3",
              title: "Heading 3",
              class: "ck-heading_heading3",
            },
            {
              model: "heading4",
              view: "h4",
              title: "Heading 4",
              class: "ck-heading_heading4",
            },
            {
              model: "heading5",
              view: "h5",
              title: "Heading 5",
              class: "ck-heading_heading5",
            },
            {
              model: "heading6",
              view: "h6",
              title: "Heading 6",
              class: "ck-heading_heading6",
            },
          ],
        },
        htmlSupport: {
          allow: [
            {
              name: /^.*$/,
              styles: true,
              attributes: true,
              classes: true,
            },
          ],
          disallow: [
            {
              name: /^.*$/,
              attributes: {
                key: /^on.*$/, // disable 'on*' attributes, like 'onClick', 'onError' etc.
              },
            },
            {
              name: "script,iframe",
            },
          ],
        },
        image: {
          toolbar: [
            "toggleImageCaption",
            "imageTextAlternative",
            "|",
            "imageStyle:inline",
            "imageStyle:wrapText",
            "imageStyle:breakText",
            "|",
            "resizeImage",
            "|",
            "ckboxImageEdit",
          ],
        },
        link: {
          addTargetToExternalLinks: true,
          defaultProtocol: "https://",
          decorators: {
            toggleDownloadable: {
              mode: "manual",
              label: "Downloadable",
              attributes: {
                download: "file",
              },
            },
          },
        },
        list: {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true,
          },
        },
        placeholder: "Напишите что-нибудь здесь!",
        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableProperties",
            "tableCellProperties",
          ],
        },
      },
    };
  },
  created() {
    //console.log(this.$model.isMainHost)
    this.dateFormatter = useDate();
    if (this.id) {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/getMessage",
          new URLSearchParams({
            id: this.id,
          }),
        )
        .then((response) => {
          this.selectedRoles = response.data.type_mess;
          this.editorData = response.data.text_mess;
          this.computedDateFormatted = response.data.date_end;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  methods: {
    async save() {
      if (!this.editorData) {
        return;
      }
      this.$refs.form.validate().then(({ valid: isValid }) => {
        if (isValid) {
          this.saveButtonReadOnly = true;
          this.axios
            .post(
              this.$model.wwwroot + "/procollege/psm_desktop2/saveMessage",
              new URLSearchParams({
                role: this.selectedRoles,
                date: this.computedDateFormatted,
                text: this.editorData,
                id: this.id,
              }),
            )
            .then((response) => {
              this.saveButtonReadOnly = false;
              this.$emit("update:modelValue", false);
            })
            .catch((error) => {
              this.saveButtonReadOnly = false;
              console.log(error);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.ck.ck-balloon-panel.ck-balloon-panel_visible {
  z-index: 10000;
}
p.first-line-indent {
  text-indent: 2em;
}
</style>
